//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Tools from './_tools'
import Tpl from '@/components/views/_tpl'

export default {
    data() {
        return {
        }
    },
    components: {
        Tools,
        Tpl,

    },
    onShareAppMessage () {
        const sub_page = encodeURIComponent('/packageA/material/main')
        const shareOpt = {
            title: '成都购房常见问题、资格查询、相关模板都在这里啦',
            path: `/index/main?sub_page=${sub_page}`
        }
        return this.getShareInfo(shareOpt)
    },
    methods: {
        goHousePurchase() {
            this.$sendCtmEvtLog(`购房流程banner点击`)
            wx.navigateTo({
                url: '/packageA/material/house_purchase'
            })
        },
    }
}
